import type { PlainButtonProps } from '@customerio/pluma-components/react';
import { Icon, PlainButton, Spinner, VisuallyHidden } from '@customerio/pluma-components/react';
import type { IconName } from '@customerio/pluma-icons';
import clsx from 'clsx';
import { forwardRef } from 'react';
import * as styles from './index.css';

/**
 * Icon Button component for the top navigation actions.
 */
export const IconButton = forwardRef<
  HTMLButtonElement,
  {
    icon: IconName;
    label: string;
    isLoading?: boolean;
    children?: React.ReactNode;
    className?: string;
  } & PlainButtonProps
>(function IconButton({ icon, label, isLoading, children, className, ...rest }, ref) {
  return (
    <PlainButton ref={ref} className={clsx(styles.iconButton, className)} {...rest}>
      <VisuallyHidden>{label}</VisuallyHidden>

      <div className={styles.iconButtonIcon}>
        {isLoading === true ? <Spinner color="invert" /> : <Icon name={icon} size="fill" />}
      </div>
      {children}
    </PlainButton>
  );
});
